<template>
  <div class="deduction-record-container">
    <!-- 查询条件 -->
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>扣费记录查询</span>
      </div>
      <el-row :gutter="24">
          <el-col :span="3">
              <el-select v-model="queryInfo.type" placeholder="订单类型" clearable>
                  <el-option label="明细" value="明细" />
                  <el-option label="日期" value="日期" />
                  <el-option label="商铺" value="商铺" />
              </el-select>
          </el-col>
        <el-col :span="3">
          <el-input v-model="queryInfo.meterNo" placeholder="电表号" clearable />
        </el-col>
        <el-col :span="3">
          <el-input v-model="queryInfo.roomNum" placeholder="房间编号" clearable />
        </el-col>
        <el-col :span="3">
          <el-input v-model="queryInfo.remark" placeholder="商铺名" clearable />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="_queryMethod">
            查询
          </el-button>
          <el-button @click="_resetQuery">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 扣费记录列表 -->
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>扣费记录列表</span>
        <div>
          <span class="total-amount" style="margin-right: 16px">合计：¥{{ totalAmount }}</span>
          <el-button type="primary" size="small" icon="el-icon-download" @click="handleExport">
            导出
          </el-button>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="meterNo" label="电表号" align="center" width="120" />
        <el-table-column prop="roomNum" label="房间编号" align="center" width="80" />
        <el-table-column prop="remark" label="商铺名" align="center" width="200" show-overflow-tooltip />
        <el-table-column prop="billDate" label="账单日期" align="center" width="100"  show-overflow-tooltip/>
        <el-table-column prop="lastDate" label="上次抄表日期" align="center" width="160"  show-overflow-tooltip>

            <template #default="{ row }">
                {{ formatTime(row.lastDate) }}
            </template>
        </el-table-column>
        <el-table-column prop="lastReading" label="上次读数" align="center" width="80">
          <template #default="{ row }">
            {{ row.lastReading || '-' }}
          </template>
        </el-table-column>
          <el-table-column prop="currentDate" label="本次抄表日期" align="center" width="160"  show-overflow-tooltip>
              <template #default="{ row }">
                  {{ formatTime(row.currentDate) }}
              </template>
          </el-table-column>
        <el-table-column prop="currentReading" label="本次读数" align="center" width="80">
          <template #default="{ row }">
            {{ row.currentReading || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="usageAmount" label="用电量(kWh)" align="center" width="70">
          <template #default="{ row }">
            {{ row.usageAmount || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="consumeAmount" label="扣费金额" align="center" width="80">
          <template #default="{ row }">
            <span style="color: #f56c6c">¥{{ row.consumeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" align="center" width="100">
          <template #default="{ row }">
            ¥{{ row.balance || 0 }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listElectricMeterDeductionRecords, exportElectricMeterDailyBill } from '@/api/community/electricMeterApi'

export default {
  name: 'DeductionRecordList',
  data() {
    return {
      loading: false,
      dateRange: [],
        totalAmount: 0,
      queryInfo: {
        type: '明细',
        meterNo: '',
        roomNum: '',
        remark: '',
        startTime: '',
        endTime: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this._loadData()
  },
  watch: {
    dateRange(val) {
      if (val && val.length === 2) {
        this.queryInfo.startTime = val[0]
        this.queryInfo.endTime = val[1]
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
    }
  },
  methods: {
    // 加载数据
    _loadData() {
      this.loading = true
      const params = {
        ...this.queryInfo,
        page: this.pagination.current,
        row: this.pagination.size,
        communityId: getCommunityId()
      }

      listElectricMeterDeductionRecords(params).then(res => {
        this.tableData = res.data || []
        this.pagination.total = res.total || 0
          this.totalAmount = res.totalAmount || 0
        this.loading = false
      }).catch(error => {
        console.error('请求失败', error)
        this.$message.error(error.message || '获取扣费记录失败')
        this.loading = false
      })
    },
    // 查询
    _queryMethod() {
      this.pagination.current = 1
      this._loadData()
    },
    // 重置查询
    _resetQuery() {
      this.queryInfo = {
        meterNo: '',
        roomNum: '',
        type: '明细',
        remark: '',
        startTime: '',
        endTime: ''
      }
      this.dateRange = []
      this._queryMethod()
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.size = val
      this._loadData()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.pagination.current = val
      this._loadData()
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 导出扣费记录
    async handleExport() {
      try {
        await exportElectricMeterDailyBill({
            communityId : getCommunityId(),
          meterNo: this.queryInfo.meterNo,
          roomNum: this.queryInfo.roomNum,
          type: this.queryInfo.type,
          remark: this.queryInfo.remark,
          startTime: this.queryInfo.startTime,
          endTime: this.queryInfo.endTime
        })
        this.$message.success('导出任务已提交，请到下载中心查看')
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(error.message || '导出失败')
      }
    }
  }
}
</script>

<style scoped>
.deduction-record-container {
  padding: 20px;
}
.total-amount {
    color: #c23a3a;
    font-weight: bold;
    font-size: 16px;
}
</style>
